import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { ApiRequestFunction } from 'utils/request/useApi';
import type { WebHookId, WebHooksState } from '../WebHooksState';

export interface LoadRecentDeliveriesCommand {
  id: WebHookId;
}

export const makeLoadRecentDeliveries =
  (
    updateState: DraftStateUpdater<WebHooksState>,
    apiRequest: ApiRequestFunction,
  ) =>
  async ({ id }: LoadRecentDeliveriesCommand): Promise<void> => {
    try {
      updateState((draft) => {
        draft.deliveriesFetching = true;
      });

      const deliveries = await apiRequest({
        url: `/webhooks/${id}/delivery`,
        method: 'GET',
      });

      if (Array.isArray(deliveries)) {
        updateState((draft) => {
          draft.recentDeliveries = deliveries;
        });
      }
    } finally {
      updateState((draft) => {
        draft.deliveriesFetching = false;
      });
    }
  };
